import { render, staticRenderFns } from "./DginCreate.vue?vue&type=template&id=53f8427d&scoped=true"
import script from "./DginCreate.vue?vue&type=script&lang=js"
export * from "./DginCreate.vue?vue&type=script&lang=js"
import style0 from "./DginCreate.vue?vue&type=style&index=0&id=53f8427d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f8427d",
  null
  
)

export default component.exports